__turbopack_context__.v({
  "accordionSlideOverwrite": "partnerForgotPasswordForm-module-scss-module__VtDRqa__accordionSlideOverwrite",
  "actions": "partnerForgotPasswordForm-module-scss-module__VtDRqa__actions",
  "fadeIn": "partnerForgotPasswordForm-module-scss-module__VtDRqa__fadeIn",
  "fadeOut": "partnerForgotPasswordForm-module-scss-module__VtDRqa__fadeOut",
  "fieldRow": "partnerForgotPasswordForm-module-scss-module__VtDRqa__fieldRow",
  "form": "partnerForgotPasswordForm-module-scss-module__VtDRqa__form",
  "formItem": "partnerForgotPasswordForm-module-scss-module__VtDRqa__formItem",
  "header": "partnerForgotPasswordForm-module-scss-module__VtDRqa__header",
  "inputField": "partnerForgotPasswordForm-module-scss-module__VtDRqa__inputField",
  "inputWrapper": "partnerForgotPasswordForm-module-scss-module__VtDRqa__inputWrapper",
  "label": "partnerForgotPasswordForm-module-scss-module__VtDRqa__label",
  "link": "partnerForgotPasswordForm-module-scss-module__VtDRqa__link",
  "phoneInputWrapper": "partnerForgotPasswordForm-module-scss-module__VtDRqa__phoneInputWrapper",
  "scaleIn": "partnerForgotPasswordForm-module-scss-module__VtDRqa__scaleIn",
  "scaleOut": "partnerForgotPasswordForm-module-scss-module__VtDRqa__scaleOut",
  "submitButton": "partnerForgotPasswordForm-module-scss-module__VtDRqa__submitButton",
  "zoomIn": "partnerForgotPasswordForm-module-scss-module__VtDRqa__zoomIn",
  "zoomOut": "partnerForgotPasswordForm-module-scss-module__VtDRqa__zoomOut",
});
